module.exports = __webpack_public_path__ + "img/createdby.f9cdad5b.png";